import * as yup from 'yup';

import * as routes from 'api/routes';
import { VALIDATION_ERROR } from 'endpoints/index';

export type Params =
  | {
      provider: 'google';
      idToken: string;
    }
  | {
      provider: 'linkedin';
      state: string;
      verifier: string;
    }
  | {
      provider: 'emailAndPassword';
      email: string;
      password: string;
    };

export const emailAndPassParamsSchema = yup.object().shape({
  email: yup.string().email(VALIDATION_ERROR.INVALID_EMAIL).required(VALIDATION_ERROR.REQUIRED),
  password: yup.string().required(VALIDATION_ERROR.REQUIRED),
});

export const paramsSchema = yup.object().shape({
  provider: yup.string().oneOf(['google', 'linkedin', 'emailAndPassword']).required(VALIDATION_ERROR.REQUIRED),
  email: yup.string().when('provider', {
    is: (provider: string) => provider === 'google' || provider === 'linkedin',
    then: yup.string().optional(),
    otherwise: yup.string().email(VALIDATION_ERROR.INVALID_EMAIL).required(VALIDATION_ERROR.REQUIRED),
  }),
  idToken: yup.string().when('provider', {
    is: 'google',
    then: yup.string().required(VALIDATION_ERROR.REQUIRED),
    otherwise: yup.string().optional(),
  }),
  state: yup.string().when('provider', {
    is: 'linkedin',
    then: yup
      .string()
      .matches(/^[a-f0-9]{64}$/)
      .required(VALIDATION_ERROR.REQUIRED),
    otherwise: yup.string().optional(),
  }),
  verifier: yup.string().when('provider', {
    is: 'linkedin',
    then: yup
      .string()
      .matches(/^[a-f0-9]{64}$/)
      .required(VALIDATION_ERROR.REQUIRED),
    otherwise: yup.string().optional(),
  }),
  pictureUrl: yup.string().optional(),
  name: yup.string().optional(),
  password: yup
    .string()
    .optional()
    .when(['provider'], {
      is: 'emailAndPassword',
      then: yup.string().required(VALIDATION_ERROR.REQUIRED),
    }),
});

export const ROUTE = routes.AUTH_USER;
